(function () {
  function initializeProductPage(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var mainImage = root.querySelector('[data-pdp-main-image]');
    var thumbnails = root.querySelectorAll('[data-pdp-thumb]');

    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        if (!mainImage) return;

        thumbnails.forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });

        thumbnail.classList.add('is-active');
        thumbnail.setAttribute('aria-pressed', 'true');
        mainImage.classList.add('is-changing');

        window.setTimeout(function () {
          mainImage.src = thumbnail.dataset.src;
          mainImage.alt = thumbnail.dataset.alt || '';
          mainImage.classList.toggle('is-contain', thumbnail.dataset.fit === 'contain');
          mainImage.classList.remove('is-changing');
        }, 120);
      });
    });

    var offers = root.querySelectorAll('[data-pdp-offer]');
    var quantityInput = root.querySelector('[data-pdp-quantity]');
    var buttonLabel = root.querySelector('[data-pdp-button-label]');
    var buttonPrice = root.querySelector('[data-pdp-button-price]');
    var mobileBuy = root.querySelector('[data-pdp-mobile-buy]');
    var mobileLabel = root.querySelector('[data-pdp-mobile-label]');
    var mobilePrice = root.querySelector('[data-pdp-mobile-price]');

    function updateMobileBuy(offer) {
      if (!offer) return;
      if (mobileLabel) mobileLabel.textContent = offer.dataset.buttonLabel || '';
      if (mobilePrice) mobilePrice.textContent = offer.dataset.price || '';
    }

    offers.forEach(function (offer) {
      offer.addEventListener('click', function () {
        offers.forEach(function (item) {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });

        offer.classList.add('is-selected');
        offer.setAttribute('aria-pressed', 'true');

        if (quantityInput) quantityInput.value = offer.dataset.quantity || '1';
        if (buttonLabel) buttonLabel.textContent = offer.dataset.buttonLabel || '';
        if (buttonPrice) buttonPrice.textContent = offer.dataset.price || '';
        updateMobileBuy(offer);
      });
    });

    updateMobileBuy(root.querySelector('[data-pdp-offer].is-selected'));

    if (mobileBuy) {
      var primaryButton = root.querySelector('.itchova-pdp__add');
      var finalButton = document.querySelector('.itchova-final__submit');
      var visibility = new Map();

      function updateMobileBar() {
        var purchaseButtonVisible = Array.from(visibility.values()).some(Boolean);
        mobileBuy.classList.toggle('is-visible', !purchaseButtonVisible);
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            visibility.set(entry.target, entry.isIntersecting);
          });
          updateMobileBar();
        }, { threshold: 0.2 });

        [primaryButton, finalButton].filter(Boolean).forEach(function (button) {
          visibility.set(button, false);
          observer.observe(button);
        });
      } else {
        mobileBuy.classList.add('is-visible');
      }
    }
  }

  function initializeAll(scope) {
    (scope || document).querySelectorAll('[data-itchova-pdp]').forEach(initializeProductPage);
    (scope || document).querySelectorAll('[data-itchova-routine-link]').forEach(function (link) {
      if (link.dataset.routineInitialized === 'true') return;
      link.dataset.routineInitialized = 'true';

      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;

        var target = document.querySelector(href);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        target.classList.add('is-routine-highlighted');

        window.setTimeout(function () {
          var selectedOffer = target.querySelector('[data-pdp-offer].is-selected') || target.querySelector('[data-pdp-offer]');
          if (selectedOffer) selectedOffer.focus({ preventScroll: true });
        }, 650);

        window.setTimeout(function () {
          target.classList.remove('is-routine-highlighted');
        }, 1800);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
